export const BANK_TRANSFER_INFO_BY_CURRENCY = {
  SAR: {
    bankAccountName: 'TAMARA FINANCE COMPANY',
    iBan: 'SA8845000000011788320007',
    bank: 'The Saudi Awwal Bank',
    swiftCode: 'SABBSARI',
  },
  AED: {
    bankAccountName: 'TAMARA FZE',
    iBan: 'AE750200000023692890005',
    bank: 'HSBC Bank Middle East LTD',
    swiftCode: 'BBMEAEAD',
  },
}
